export default __webpack_public_path__ + "e1b5d6404b0d802dc83166d4d52cd3fb.png";